module.exports = __webpack_public_path__ + "img/public/siteImages/alert.png?d079eff9";